import { Component, OnInit, Input } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { VenueModelResponse } from 'src/app/_models/Venue/VenueModel';
import { ApiService } from 'src/app/_services/api.service';
import { ViewVenueDialogComponent } from '../view-venue-dialog/view-venue-dialog.component';
import { Operations } from 'src/app/_models/Operations/Operations';
import {VenueCapacityDialogComponent} from "../venue-capacity-dialog/venue-capacity-dialog.component";

@Component({
  selector: 'app-venue-item',
  templateUrl: './venue-item.component.html',
  styleUrls: ['./venue-item.component.scss']
})
export class VenueItemComponent implements OnInit {

  @Input() venue?: VenueModelResponse;
  @Input() businessTypes: any;
  @Input() companyCountryCode?: string;

  constructor(
    private apiService: ApiService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  addVenueCapacity(venueID: string | undefined) {
    const dialogRef = this.dialog.open(VenueCapacityDialogComponent, {
      data : {
        venueId: venueID,
      },
      panelClass: 'custom-modal'
    })

    dialogRef.afterClosed().subscribe(closed => {
      if(!closed) {
        this.apiService.getVenues().subscribe();
      }
    });
  }

  viewVenue(venueID: string | undefined) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.panelClass = 'custom-modal';

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      venueId: venueID,
      businessTypes: this.businessTypes,
      companyCountryCode: this.companyCountryCode
    };

    const dialogRef = this.dialog.open(ViewVenueDialogComponent, dialogConfig)

    dialogRef.afterClosed().subscribe(closed => {
      if(!closed) {
        this.apiService.getVenues().subscribe();
      }
    });
  }
}
